
<template>
	<div>
		<!--== Start Header Wrapper ==-->
		<header class="main-header">
			<!-- header-middle start -->
			<div class="header-middle mobile-sticky" :class="stickyHeader ? 'sticky' : ''">
				<div class="container">
					<div class="row">
						<div class="col-12">
							<div class="row">
								<div class="col-sm-12 col-lg-6 col-md-6">
									<div class="header-middle-content">
										<div class="header-logo">
											<a href="index.html">
												<img
													class="sticky-img"
													src="../../assets/img/logo-daring.png"
													alt="Logo"
												/>
											</a>
										</div>
										<div class="mobile-menu-toggle d-lg-none">
											<a href="#offcanvas-mobile-menu" class="offcanvas-toggle">
												<svg viewBox="0 0 800 600" @click.prevent="toggleCanvasMobile">
													<path
														d="M300,220 C300,220 520,220 540,220 C740,220 640,540 520,420 C440,340 300,200 300,200"
														id="top"
													></path>
													<path d="M300,320 L540,320" id="middle"></path>
													<path
														d="M300,210 C300,210 520,210 540,210 C740,210 640,530 520,410 C440,330 300,190 300,190"
														id="bottom"
														transform="translate(480, 320) scale(1, -1) translate(-480, -318)"
													></path>
												</svg>
											</a>
										</div>
									</div>
								</div>
								<div v-if="!stickyHeader" class="col-sm-12 col-lg-6 col-md-6">
									<div>
										<ul class="social-links text-sm-left text-lg-right text-md-right pl-0 mt-4 mt-md-0 mb-0 mb-md-2">
											<li>
												<a href="#" class="link-reg-log" @click="showModalLogin"><i class="icofont-login"></i><span><strong>MASUK</strong></span></a>
											</li>
											<!-- <li>
												<a href="#" class="link-reg-log" @click="showModalregister"><i class="icofont-user-alt-1"></i><span><strong>DAFTAR</strong></span></a>
											</li> -->
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- header-middle end -->

			<!-- header-bottom start -->
			<div class="header-bottom d-none d-lg-block">
				<div class="container">
					<div class="row">
						<div class="col-lg-12">
							<div class="d-flex flex-wrap align-items-center justify-content-between">
								<ul class="main-menu pl-0">
									<li>
										<a class="main-menu-link" href="/">Home</a>
									</li>
									<li>
										<a class="main-menu-link" href="#" @click="programLayananMenu">Program Layanan</a>
									</li>
									<li>
										<a class="main-menu-link" href="#" @click="contactUsMenu">Contact Us</a>
									</li>
									<li>
										<a class="main-menu-link" href="/public/profile">Profile</a>
									</li>
									<li>
										<a class="main-menu-link" href="https://emodul.kemdikbud.go.id">E-Modul</a>
									</li>
									
								</ul>
								<div class="d-flex">
									<!-- <a href="#" class="book-now-btn mx-2">Panduan Penggunaan</a>
									<a href="#" class="book-now-btn mx-2">Penggunaan Penyelenggaraan</a> -->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- header-bottom end -->
			<!-- header-bottom start -->
			<div class="header-bottom sticky-header d-none d-lg-block" :class="stickyHeader ? 'sticky' : ''">
				<div class="container">
					<div class="row">
						<div class="col-lg-12">
							<div
								class="d-flex flex-wrap align-items-center justify-content-between"
							>
								<ul class="main-menu pl-0">
									<li>
										<a class="main-menu-link" href="/"
											>Home</a
										>
									</li>
									<li>
										<a class="main-menu-link" href="#"
										@click="programLayananMenu"
											>Program Layanan</a
										>
									</li>
									<li>
										<a class="main-menu-link" href="#" @click="contactUsMenu">Contact Us</a>
									</li>
									<li>
										<a class="main-menu-link" href="/public/profile">Profile</a>
									</li>
									<li>
										<a class="main-menu-link" href="https://emodul.kemdikbud.go.id">E-Modul</a>
									</li>
								</ul>
								<div class="d-flex">
									<!-- <a href="#" class="book-now-btn mx-2">Panduan Penggunaan</a>
									<a href="#" class="book-now-btn mx-2">Penggunaan Penyelenggaraan</a> -->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- header-bottom end -->
		</header>
		<!--== End Header Wrapper ==-->

      <!-- offcanvas-overlay start -->
      <div class="offcanvas-overlay"></div>
      <!-- offcanvas-overlay end -->
      <!-- offcanvas-mobile-menu start -->
      <div id="offcanvas-mobile-menu" class="offcanvas offcanvas-mobile-menu" :class="showCanvasMobile ? 'offcanvas-open' : ''">
        <div class="inner">
          <div class="border-bottom mb-3 pb-3 text-end">
            <button class="offcanvas-close" @click.prevent="toggleCanvasMobile">×</button>
          </div>
          <div class="offcanvas-head mb-3">
            <div class="header-top-offcanvas">
              <p>
                <i class="icofont-google-map"></i> Jl. Jend. Ahmad Yani no. 136 Kode Pos 46213 Ciamis
              </p>
            </div>
          </div>
          <nav class="offcanvas-menu">
            <ul>
              <li>
                <a href="#"><span class="menu-text">Home</span></a>
                <ul class="offcanvas-submenu">
                  <li><a href="/">Home 1</a></li>
                </ul>
              </li>
              <li><a href="#0" @click="programLayananMenu">Program Layanan</a></li>
              <li><a href="#0" @click="contactUsMenu">Contact Us</a></li>
              <li><a href="/public/profile">Profile</a></li>
              <li><a href="https://emodul.kemdikbud.go.id">E-Modul</a></li>
            </ul>
          </nav>
          <div class="offcanvas-social my-4">
            <ul>
              <li>
                <a href="https://www.facebook.com/pkbm.binapandumandiri.96"><i class="icofont-facebook"></i></a>
              </li>
              <li>
                <a href="https://www.instagram.com/pkbm_bina_pandu_mandiri/?igshid=18bmygdqc418f"><i class="icofont-instagram"></i></a>
              </li>
            </ul>
          </div>

          <ul class="media-wrap">
            <!-- media-list start -->
            <li class="media media-list">
              <span class="media-icon"><i class="icofont-envelope"></i></span>
              <div class="media-content">
                <span class="media-sub-heading">Email kami</span>
                <a style="font-size:10px" class="media-heading" href="mailto:binapandumandiri@gmail.com"
                  >binapandumandiri@gmail.com</a
                >
              </div>
            </li>
            <!-- media-list end -->
          </ul>
        </div>
      </div>
      <!-- offcanvas-mobile-menu end -->

		<b-modal
			ref="register-modal"
			class="login-model"
			size="md"
			hide-footer
			hide-header
			no-close-on-backdrop
		>
		<register-form></register-form>
		</b-modal>
		<b-modal
			ref="login-modal"
			class="login-model"
			size="md"
			hide-footer
			hide-header
			no-close-on-backdrop
		>
		<login-form></login-form>
		</b-modal>
	</div>
</template>
<script>
//   import {FadeTransition} from 'vue2-transitions';
	import LoginForm from "../../components/Main/LoginForm";
	import RegisterForm from "../../components/Main/RegisterForm";
    import { EventBus } from '@/eventBus.js'
  export default {
    components: {
    //   FadeTransition
		RegisterForm,
		LoginForm
	},
    data() {
      return {
				stickyHeader: false,
				showCanvasMobile: false
      }
    },
    created () {
		window.addEventListener('scroll', this.handleScroll);
		EventBus.$on('hideModalRegister', (val) => {
			if (val) {
				this.hideModalRegister()
			}
		})
		EventBus.$on('hideModalLogin', (val) => {
			if (val) {
				this.hideModalLogin()
			}
		})
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
		showModalLogin() {
			this.$refs['login-modal'].show()
		},
		hideModalLogin() {
			this.$refs['login-modal'].hide()
		},
		showModalregister() {
			this.$refs['register-modal'].show()
		},
		hideModalRegister() {
			this.$refs['register-modal'].hide()
		},
		toggleCanvasMobile() {
			this.showCanvasMobile = !this.showCanvasMobile
		},
		handleScroll () {
			if (window.pageYOffset > 150) {
				this.stickyHeader = true
			} else {
				this.stickyHeader = false
			}
		},
		programLayananMenu() {
            EventBus.$emit('scrollToPackage', true)
		},
		contactUsMenu() {
            EventBus.$emit('scrollToContact', true)
		}
    }
  };
</script>
<style lang="css" scoped>
.link-reg-log:hover {
    text-decoration: unset;
}
.link-reg-log span {
	font-weight: 400;
	font-size: 14px;
}
.sticky-img{
	width: 50px;
}
.sticky-img-200{
	width: 200px;
}
@media only screen and (max-width: 767px) {
  .sticky-img{
    width: 30px;
  }
}
</style>